<template>
  <div class="index">
    <div style="margin-bottom: 10px">
      <el-breadcrumb slot="breadcrumb" class="breadcrumb-bg">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>文章列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
      <el-card>
          <el-button type="primary" size="small" @click="add">添加文章</el-button>
          <el-row  v-for="(item,index) in menu_data" :key="index">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                 <p class="title"> {{item.title}}
                     <el-button type="primary" size="small" @click="edit(item)">编辑</el-button>
                     <el-button type="danger" size="small" @click="del(item)">删除</el-button>
                 </p>
                  <el-row v-for="(item1,index1) in item.child" :key="index1" style="height: 50px;" >
                      <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5"  >

                          {{item1.title}}

                      </el-col>

                      <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" >

                        <span>{{item1.component}}</span>
                      </el-col>
                      <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" >

                          <span>{{item1.path}}</span>
                      </el-col>
                      <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" >

                          <el-button type="primary" @click="edit(item1)">编辑</el-button>
                          <el-button type="danger" @click="del(item1)">删除</el-button>
                      </el-col>
                  </el-row>

              </el-col>

          </el-row>
      </el-card>


  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      menu_data:[],




    };
  },
  methods: {
    ...mapActions({

      getMenuIndexAction:"getMenuIndexAction",
      deleteMenuAction:"deleteMenuAction"
    }),
      add(){

        this.$router.push({name:"article_add"})
      },
     edit(item){
        this.$router.push({name:"menu_edit",params:{id:item.id}})
     },
     del(item){
        this.deleteMenuAction({id:item.id})
     },


  },
  created() {
      this.getMenuIndexAction({type:1})

  },
    computed: {
    //   ...mapState({dataIndex:"index.dataIndex"}),
    ...mapState({
      result: (state) => state.menu.result,
    }),
  },
  watch: {
    result(val) {
      if (val.code == 201) {
        this.menu_data=val.data
      }
      if (val.code == 305) {
          this.$message({
              message: "请先删除子菜单",
              type: "warning",
          });

        }
        if (val.code == 306) {
            this.$message({
                message: "删除菜单成功",
                type: "success",
            });
            this.getMenuIndexAction({type:1})
        }
        if (val.code == 404) {
            this.$message({
                message: "删除菜单失败",
                type: "warning",
            });
        }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.title{
    background-color:#E6E6E6;
    color: #000000;
}
</style>
